require("./bootstrap");

require("bootstrap/js/dist/modal.js");
require("bootstrap/js/dist/tab.js");

require("alpinejs");
